import React from "react";
import styled from "styled-components";

export default styled.select`
    border: 1px solid #979797;
    width:591px; 
    height: 50px;
    padding: 5px 10px;
    margin-bottom: 7px;
`;